module.exports = __webpack_public_path__ + "static/media/home.8c4cd4fc.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/home.mov
// module id = 617
// module chunks = 0